import React from "react";

interface TitleProps {
  id?: string;
  title?: string;
}

const Title = ({id, title}: TitleProps) => {
    return (
        <h2 id={id} data-testid={id} className={`tw-text-[#090942] tw-text-sm tw-font-semibold`}>{title ?? ''}</h2>
    );
}

export default Title;